﻿import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* 初始路由 */
const router = [{
  path: '*',
  name: '404',
  component: () => import('@/pages/errorPage/404.vue'),
}]

export default new Router({
  mode: 'history',
  routes: router
});



// WEBPACK FOOTER //
// ./src/router/index.js